/**
 * Mock regulatory feed (spec §5.6) — design-only. Realistic export-control news
 * items; the "affects N of your products" matching is mocked.
 */

export type RegSeverity = 'info' | 'warning' | 'danger';

export interface RegulationItem {
  id: string;
  date: string;
  source: string;
  category: string;
  title: string;
  summary: string;
  affects: number | null;
  severity: RegSeverity;
  link?: string;
}

export const REGULATION_FEED: RegulationItem[] = [
  {
    id: 'reg-1',
    date: '2026-06-10',
    source: 'BIS',
    category: 'CCL Update',
    title: 'New ECCN 3A090 controls expanded for advanced computing items',
    summary:
      'The Bureau of Industry and Security amended the Commerce Control List to broaden parameters under 3A090, adding license requirements for additional destinations.',
    affects: 6,
    severity: 'warning',
  },
  {
    id: 'reg-2',
    date: '2026-06-04',
    source: 'OFAC',
    category: 'Sanctions',
    title: 'New SDN designations target procurement networks',
    summary:
      'OFAC added 23 entities and 11 individuals to the SDN List for involvement in evasion of export controls. Screen affected customers and consignees.',
    affects: 3,
    severity: 'danger',
  },
  {
    id: 'reg-3',
    date: '2026-05-28',
    source: 'DDTC',
    category: 'USML Revision',
    title: 'USML Category VIII clarification on commercial aircraft parts',
    summary:
      'A final rule clarifies the boundary between USML Category VIII and the CCL for certain aircraft components, moving some parts to EAR jurisdiction.',
    affects: 4,
    severity: 'info',
  },
  {
    id: 'reg-4',
    date: '2026-05-19',
    source: 'Federal Register',
    category: 'Rule',
    title: 'Quarterly update to the Entity List',
    summary:
      'Additions and removals to the Entity List take effect, with new license requirements and review policies for several listed parties.',
    affects: 2,
    severity: 'warning',
  },
  {
    id: 'reg-5',
    date: '2026-05-08',
    source: 'BIS',
    category: 'License Exception',
    title: 'Revisions to License Exception STA eligibility',
    summary:
      'Eligibility criteria for Strategic Trade Authorization (STA) were updated for several ECCNs; re-validate exception usage on affected licenses.',
    affects: null,
    severity: 'info',
  },
  {
    id: 'reg-6',
    date: '2026-04-30',
    source: 'NRC',
    category: '10 CFR Part 110',
    title: 'Updated guidance for nuclear material export authorizations',
    summary:
      'The Nuclear Regulatory Commission issued revised guidance on Part 110 specific licenses, affecting documentation requirements for byproduct material.',
    affects: 1,
    severity: 'info',
  },
  {
    id: 'reg-7',
    date: '2026-04-22',
    source: 'OFAC',
    category: 'Sanctions',
    title: 'General License authorizing wind-down transactions',
    summary:
      'A new general license authorizes the wind-down of certain transactions through a stated date. Review linked licenses for impacted destinations.',
    affects: null,
    severity: 'info',
  },
  {
    id: 'reg-8',
    date: '2026-04-11',
    source: 'Commerce',
    category: 'Enforcement',
    title: 'Settlement underscores routed-export recordkeeping',
    summary:
      'A recent enforcement settlement highlights recordkeeping expectations for routed export transactions and end-use documentation.',
    affects: null,
    severity: 'info',
  },
];
